<script>
import { required } from "vuelidate/lib/validators";
import {cloneDeep} from "lodash";
import DatePicker from "vue2-datepicker";
import createNumberMask from "text-mask-addons/dist/createNumberMask";
import MaskedInput from "vue-text-mask";
export default {
    name: "PostToPublicModal",
    components: {
        DatePicker,
        MaskedInput
    },
    props: {
        modalTitle: String,
    },
    data(){
        return {
            submitted: false,
            publicPost: {
                rfqId: 0,
                datePublish: null,
                publicationEnded: null,
                nonRefundableBidderFee: null,
                type: 'public-bidding',
            },
            currencyMask: createNumberMask({
                prefix: "",
                includeThousandsSeparator: true,
                allowDecimal: true,
            }),
        }
    },
    validations: {
        publicPost: {
            datePublish: { required },
            publicationEnded: { required },
        },
    },
    methods: {
        onResetPublicPost(rfqId){
            this.publicPost = {
                id: 0,
                rfqId: rfqId,
                datePublish: null,
                publicationEnded: null,
                nonRefundableBidderFee: "",
                type: "public-bidding",
            };
        },
        postNow() {
            this.submitted = true;
            this.$v.publicPost.$touch();
            if (this.$v.publicPost.$invalid) {
                return;
            }
            let data = cloneDeep(this.publicPost);
            data.datePublish = this.getDate(this.publicPost.datePublish);
            data.publicationEnded = this.getDate(this.publicPost.publicationEnded);
            data.nonRefundableBidderFee = this.publicPost.nonRefundableBidderFee ? this.getExactAmt(this.publicPost.nonRefundableBidderFee) : 0;
            this.$emit('postRfqToPublic', data);
        },
    }
}
</script>
<template>
    <b-modal
        id="modal-post-to-public"
        :title="modalTitle"
        size="md"
        title-class="font-18"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
    >
        <form @submit.prevent="postNow" class="needs-validation">
            <div class="mb-3">
                <label>Publication Date </label>
                <date-picker
                    v-model="publicPost.datePublish"
                    :first-day-of-week="1"
                    lang="en"
                    placeholder="Enter Publication Date..."
                    :class="{
                        'is-invalid':
                            submitted &&
                            $v.publicPost.datePublish.$error,
                    }"
                ></date-picker>
                <div
                    v-if="
                        submitted && $v.publicPost.datePublish.$error
                    "
                    class="invalid-feedback"
                >
                    <span v-if="!$v.publicPost.datePublish.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="mb-3">
                <label>Publication Ending </label>
                <date-picker
                    v-model="publicPost.publicationEnded"
                    :first-day-of-week="1"
                    lang="en"
                    placeholder="Enter Publication Ending..."
                    :class="{
                        'is-invalid':
                            submitted &&
                            $v.publicPost.publicationEnded.$error,
                    }"
                ></date-picker>
                <div
                    v-if="
                        submitted && $v.publicPost.publicationEnded.$error
                    "
                    class="invalid-feedback"
                >
                    <span v-if="!$v.publicPost.publicationEnded.required"
                        >This value is required.</span
                    >
                </div>
            </div>
            <div class="mb-3">
                <label>Non Refundable Bidder Fee</label>
                <masked-input
                    v-model="publicPost.nonRefundableBidderFee"
                    class="form-control"
                    role="textbox"
                    placeholder="Enter Non Refundable Bidder Fee"
                    :mask="currencyMask"
                ></masked-input>
            </div>
            <div class="modal-footer">
                <button type="submit" class="btn btn-success">
                    <i class="bx bx-check"></i> {{publicPost.id == 0 ? 'Post RFQ to Public' : 'Update'}}
                </button>
                <button
                    type="button"
                    class="btn btn-link"
                    @click="$bvModal.hide('modal-post-to-public')"
                >
                    Close
                </button>
            </div>
        </form>
    </b-modal>
</template>